import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import getProfile from 'utils/getProfile'

export const useApp = () => {
  const location = useLocation()

  useEffect(() => {
    getProfile()
  }, [])

  useEffect(() => {
    if ('PLURALL_TRACKER' in window) {
      window.PLURALL_TRACKER.pageView()
    }
  }, [location])

  return null
}
